import React, { useState, useEffect } from 'react';
import Select from 'react-select'
import * as styles from '../../../config/styles'
import $ from 'jquery'

const SelectFilterAttributeMulti = (props) => {
    const tableRef = props.tableRef
    const attribute = props.attribute
    const columnIndex = props.columnIndex
    const placeholder = (props.placeholder || 'Select Status...')
    const storageKey = props.localStorageKey
    const statusColumnIsMulti = props.statusColumnIsMulti

    const [ options, setOptions ] = useState([])
    const [ values, setValues ] = useState([])

    useEffect(() => {
        const attr = attribute
        let options = []
        if( typeof attr.radio_button_values !== 'undefined' ) {
            options = attr.radio_button_values
        }
        else if( typeof attr.single_select_values !== 'undefined' ) {
            options = attr.single_select_values
        }
        options.map(status => status.label = status.value )
        setOptions(options)
    },[])

    useEffect(() => {
        // If there's nothing stored in localStorage, keep values empty
        // empty values === all selected. Just cleaner
        let values = []
        try {
            values = JSON.parse(localStorage.getItem(storageKey))
            setValues(values)
        } catch(err) {
            values = []
        }
    },[localStorage.getItem(storageKey)])
    
    useEffect(() => {
        // TODO figure out how to do this with tableRef.
        $.fn.dataTable.ext.search = [
            function( settings, data, dataIndex ) {
                const statusValue = data[columnIndex]
                const hasStatus = (element) => element.value === statusValue

                if (typeof options === 'undefined') {
                    return false
                }

                const statusFilter = values
                if (typeof statusValue === 'undefined'
                    || statusFilter === null || typeof statusFilter === 'undefined' || statusFilter.length === 0) {
                    // default to show all
                    return true
                }
                
                if( statusFilter.some(hasStatus) ) {
                    return true
                }

                return false
            }
        ];
        return () => {
            // Clear the filtering
            $.fn.dataTable.ext.search = []
        }
    }, [values])

    useEffect(() => {
        tableRef?.current?.dt()?.draw('')
    }, [values])
    
    const updateValues = (data) => {
        setValues(data)
        localStorage.setItem(storageKey,JSON.stringify(data))
    }

    return (
        <div className="col-sm-6 m-b-xs">
            <Select
                key="select-filter-attribute-multi"
                isMulti={true}
                options={options}
                value={values}
                onChange={values => updateValues(values) }
                styles={styles.multiSelect}
                closeMenuOnSelect={false}
                placeholder={placeholder}
            />
        </div>
    )
}

export default SelectFilterAttributeMulti
